module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/shapes-c2d70fa058dafd77e23e79f074230aff.png";